import {isLoggedIn} from 'utils/auth'

export default (store) => ({
  path: 'campaign-form/create',
  onEnter: isLoggedIn(store),
  getComponent(nextState, callback) {
    require.ensure([], (require) => {
      const component = require('./FormCreate').default
      callback(null, component)
    }, 'FormCreate')
  }
})



// WEBPACK FOOTER //
// ./src/routes/rule-ui-routes/FormCreate/index.js